import {
  Barcode,
  Book,
  CalendarSearch,
  MessagesIcon,
  People,
  Home,
  Note2,
  Call,
} from "shared/components/Icons";
import { Urls } from "shared/constants/url";
import { useTranslation } from "react-i18next";

const ReturnerData = () => {
  const { t } = useTranslation();
  const data = [
    {
      id: 9,
      title: "Home",
      url: Urls.HOME_URL,
      icon: <Home />,
    },
    {
      id: 1,
      title: t("news"),
      url: Urls.NEWS_URL,
      icon: <Barcode />,
      text: t("newsDescription"),
      img: "/media/live.gif",
    },
    {
      id: 2,
      title: t("discussion"),
      url: Urls.DISCUSSIONS_URL,
      icon: <MessagesIcon />,
      text: t("discussionsDescription"),
      img: "/media/customer.gif",
    },
    {
      id: 3,
      title: t("community"),
      url: Urls.COMMUNITY_URL,
      icon: <People />,
      text: t("communityDescription"),
      img: "/media/diagram.gif",
    },
    {
      id: 4,
      title: t("events"),
      url: Urls.EVENTS_URL,
      icon: <CalendarSearch />,
      text: t("eventsDescription"),
      img: "/media/calendar.gif",
    },
    {
      id: 5,
      title: t("HUBDev"),
      url: Urls.HUBDEV_URL,
      icon: <Book />,
      text: t("libraryDescription"),
      img: "/media/rocket.gif",
    },
    {
      id: 7,
      title: "About us",
      url: Urls.ABOUT_US_URL,
      icon: <Note2 />,
    },
    {
      id: 8,
      title: "Contact",
      url: Urls.CONTACT_URL,
      icon: <Call />,
    },
  ];

  return {
    data,
  };
};
export default ReturnerData;
